import { DataModel } from '../../dto/data-model.js';
import { MarketingVendorType } from './marketing-vendor-type.js';

export abstract class MarketingVendorSettings extends DataModel {
  abstract get type(): MarketingVendorType;
}
